import { API } from '../services/amplifyCompat';
import { useParams } from 'react-router-dom';
import { getActionBySlug } from '../graphql/queries';
import { useGetAllActions } from './use-get-all-actions';
import { useEffect, useState } from 'react';

export const allActionStyles = {
  0: { color: '#0F172A' },
  1: { color: '#10B981' },
  2: { color: '#E661AE' },
  5: { color: '#8CBD5B' },
  3: { color: '#6FDDDD' },
  11: { color: '#F1A660' },
  12: { color: '#FFD467' },
  13: { color: '#cf8bff' },
};

export const useGetSingleAction = () => {
  const { actionId } = useParams();
  const { allActions } = useGetAllActions();
  const isSlug = Boolean(actionId && isNaN(Number(actionId)));
  const [slugId, setSlugId] = useState(null);
  const [slugError, setSlugError] = useState(null);
  const [action, setAction] = useState(null);
  const [isLoading, setIsLoading] = useState(isSlug);

  useEffect(() => {
    let isMounted = true;

    if (!isSlug) {
      setSlugId(null);
      setSlugError(null);
      setIsLoading(false);
      return undefined;
    }

    const getSlug = async () => {
      setIsLoading(true);
      setSlugId(null);
      setSlugError(null);

      try {
        const response = await API.graphql({
          query: getActionBySlug,
          variables: { slug: actionId },
        });
        const resolvedSlugId = response?.data?.getActionBySlug?.action_id;

        if (!isMounted) {
          return;
        }

        if (resolvedSlugId == null) {
          setSlugError(new Error(`No action found for slug: ${actionId}`));
          return;
        }

        setSlugId(resolvedSlugId);
      } catch (error) {
        if (!isMounted) {
          return;
        }
        console.error('Error fetching slug:', error);
        setSlugError(error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    getSlug();

    return () => {
      isMounted = false;
    };
  }, [actionId, isSlug]);

  useEffect(() => {
    const resolvedActionId = isSlug ? slugId : actionId;

    if (resolvedActionId == null) {
      setAction(null);
      return;
    }

    const foundAction = allActions.find(({ id }) => {
      return id.toString() === resolvedActionId.toString();
    });
    setAction(foundAction);
  }, [isSlug, slugId, actionId, allActions]);

  const resolvedActionId = isSlug ? slugId : actionId;
  const actionStyles = allActionStyles[resolvedActionId ?? actionId] || allActionStyles[0];

  return {
    slugId,
    slugError,
    isLoading,
    action,
    actionStyles,
  };
};
